import { usingGet } from '@ocean/api'

export const getEducationDetails = (educationId: Guid, resultId?: Guid) => {
  const baseUrl = `educations/details/${educationId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
